export const TUTORIAL_INFO_TTL = 5000;
